
















































import Vue from 'vue';
import layout from '@/libs/layout/educational/lesson-teaching';
import { Component } from 'vue-property-decorator';
import { TTeachingLessonPage } from '@/types/views/educational';
import { getTeachingLessonPage } from '@/api/educational';
import { TLayout } from '@/types/utils';
@Component({})
export default class Lesson extends Vue {
  private query = '';
  private layout: TLayout = layout;
  private page: TTeachingLessonPage = {
    currentPage: 1,
    pageSize: 20
  };
  private activated() {
    this.search();
  }
  private handleSize(size: number) {
    this.getLessonPage({
      lessonName: this.query,
      currentPage: 1,
      pageSize: size
    });
  }

  private handlePage(page: number) {
    this.getLessonPage({
      lessonName: this.query,
      currentPage: page,
      pageSize: this.page.pageSize
    });
  }

  private async getLessonPage(options: any) {
    try {
      this.page = await getTeachingLessonPage(options);
    } catch (e) {
      this.$message.error;
    }
  }
  private goToLessonDetail(id: string) {
    this.$router.push({
      name: 'lesson-detail',
      params: {
        id
      },
      query: {
        courseId: this.$route.params.id
      }
    });
  }
  private search() {
    this.getLessonPage({
      lessonName: this.query,
      pageSize: 20,
      currentPage: 1
    });
  }
}
